<template>
    <div class="pop_overlay_black" v-if="isShow">
        <div class="pop_wrap rsv2_manager_set_pop" style="width: 940px;">
            <div v-if="isLoading" class="loading_bg" style="z-index: 999;">
                <div class="loading_wrap">
                    <div class="loading_obj">
                        <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="pop_title">
                <span class="title">{{ $t('reservation_settings.popup_group_settings.title') }}</span>
                <button class="mgl_auto" @click="action_Close"><v-icon large>mdi-close</v-icon></button>
            </div>
            <div class="pop_desc lgray black_txt">{{ $t('reservation_settings.popup_group_settings.sub_title') }}</div>
            <div class="pop_cont">
                <ul class="form_list">
                    <li class="title w_150">{{ $t('reservation_settings.popup_group_settings.label_group_name') }}</li>
                    <li class="cont">
                        <input type="text" class="input_s w_full" :placeholder="$t('reservation_settings.popup_group_settings.placeholder_group_name')" maxlength="30" v-model="group.title" @focus="action_InputFocus">
                        <small class="red_txt" v-if="isErrorName">{{ $t('reservation_settings.popup_group_settings.label_group_name_required') }}</small>
                        <small class="red_txt" v-if="isErrorNameDuplicated && isErrorName!=true">이미 사용중인 그룹명입니다. 다른 명칭으로 설정해 주세요.</small>
                    </li>
                </ul>
                <hr>
                <div v-if="isSaaS == false">
                    <ul class="form_list">
                        <li class="title">채팅 알림 설정</li>
                        <li class="w_full">
                            <small class="lgray_txt fr">해당 그룹에 예약이 등록된 경우, 환자가 설치한 앱 내 채팅을 통해 아래 설정한 알림이 발송됩니다.</small>
                        </li>
                    </ul>
                    <GroupNotice v-model="group" @action_Focus="action_MessageFocus"/>
                    <div v-if="isErrorMessage"><small class="red_txt mgt_5">알림 내용을 입력해주세요.</small></div>
                </div>
                <MessagesComponent
                    :group="group"
                />
                <div class="btn_wrap relative">
                    <span class="abs_left">
                        <button v-if="isCreate==false" class="btn_underline dgray_txt" @click="action_Remove"><v-icon small>mdi-trash-can-outline</v-icon> {{ $t('reservation_settings.popup_group_settings.label_delete_group') }}</button>
                    </span>
                    <button class="btn btn_l btn_dgray" @click="action_Close">{{ $t('common.cancel') }}</button>
                    <button class="btn btn_l btn_blue" @click="action_Save">{{ $t('common.save') }}</button>
                </div> 
            </div>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import GroupNotice from './GroupNotice'
import MessagesComponent from './NoticeMessages/MessagesComponent.vue'
import { closeAlertPopup, showAlertPopup } from '../../../sheet-alert'
import { sheetState } from '../../../sheet-state'
import { hideGroupSetting, sheetOverlays } from '../../../sheet-overlays'
import { sheetFilters, saveGroups } from '../../../sheet-filters'
import { useQueryClient } from '@tanstack/vue-query'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { v2ReservationGroupFindQueryOptions } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-find-query'
import { useV2ReservationGroupCreateMutation } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-create-mutation'
import { useV2ReservationGroupUpdateMutation } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-update-mutation'
import { useV2ReservationGroupRemoveMutation } from '@/composables/queries/v2reservationgroup/use-v2-reservationgroup-remove-mutation'
import { reservationGroupDefaultTemplatesQueryOptions } from '@/composables/queries/reservationgroup/use-reservation-group-default-templates-query'
const moment = require('../../../../../../../util/MPMoment')
export default {
    setup() {
        const queryClient = useQueryClient()
        const { mutateAsync: createReservationGroup } = useV2ReservationGroupCreateMutation()
        const { mutateAsync: updateReservationGroup } = useV2ReservationGroupUpdateMutation()
        const { mutateAsync: removeReservationGroup } = useV2ReservationGroupRemoveMutation()
        return { queryClient, createReservationGroup, updateReservationGroup, removeReservationGroup }
    },
    components: { GroupNotice, MessagesComponent },
    data() {
        return {
            sheetState,
            sheetOverlays,
            sheetFilters,
            isLoading: false,
            isErrorName: false,
            isErrorNameDuplicated: false,
            isErrorMessage: false,

            defaultTemplates: {},
            
            group: {},
        }
    },
    watch: {
        isShow: {
            handler: async function(newValue) {
                if (newValue == false) { return }
                this.initGroup()
                this.isErrorName = false
                this.isErrorNameDuplicated = false
                this.isErrorMessage = false
            }
        }
    },
    computed: {
        isShow: function() { return this.sheetOverlays.isShowGroupSetting },
        isCreate: function() { return this.group?._id == undefined },
        isSaaS: function() { return this.hospital.selectedHospital.isEnabledSaaS },
    },
    methods: {
        action_Close() {
            hideGroupSetting()
        },
        async action_Save() {
            if (await this.validate() == true) {
                try {
                    if (this.group._id == undefined) {
                        await this.createGroup()
                    }
                    else {
                        await this.updateGroup()
                    }
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 중단
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                    return
                }
                if (this.sheetOverlays.groupSettingHandler != undefined) {
                    this.sheetOverlays.groupSettingHandler()
                }
                this.action_Close()
            }
        },
        action_Remove() {
            showAlertPopup('AlertGroupRemoveConfirm', this.handleAlertRemovePopupLeft, this.handleAlertRemovePopupRight)
        },
        action_InputFocus() {
            this.isErrorName = false
            this.isErrorNameDuplicated = false
        },
        action_MessageFocus() {
            this.isErrorMessage = false
        },


        // MARK: - Alert Handler
        handleAlertRemovePopupLeft() {
            closeAlertPopup()
        },
        async handleAlertRemovePopupRight() {
            this.sheetState.isPopupLoading = true
            await this.removeGroup()
            this.sheetState.isPopupLoading = false
            closeAlertPopup()
            
            if (this.sheetOverlays.groupSettingHandler != undefined) {
                this.sheetOverlays.groupSettingHandler()
            }
            this.action_Close()
        },


        // MARK: - private
        async initGroup() {
            if (this.isSaaS) {
                await this.loadDefaultTemplates()
                const newGroup = deepCopy(this.sheetOverlays.selectedGroup) ?? {}
                if (newGroup._id == undefined || newGroup._id == '') {
                    newGroup.messageImmediateCreate = this.defaultTemplates.createImmediate.kakaoTemplateHistoryID.templateContent.replace(/#\{([^}]*)\}/g, '{{$1}}')
                    newGroup.messageImmediateCreateHistoryID = this.defaultTemplates.createImmediate.kakaoTemplateHistoryID
                    newGroup.messageImmediateUpdate = this.defaultTemplates.updateImmediate.kakaoTemplateHistoryID.templateContent.replace(/#\{([^}]*)\}/g, '{{$1}}')
                    newGroup.messageImmediateUpdateHistoryID = this.defaultTemplates.updateImmediate.kakaoTemplateHistoryID
                    newGroup.messageImmediateRemove = this.defaultTemplates.removeImmediate.kakaoTemplateHistoryID.templateContent.replace(/#\{([^}]*)\}/g, '{{$1}}')
                    newGroup.messageImmediateRemoveHistoryID = this.defaultTemplates.removeImmediate.kakaoTemplateHistoryID

                    newGroup.usingMessageReservationBefore0 = false
                    newGroup.messageTimeReservationBefore0 = moment('2000-01-01', 'YYYY-MM-DD').startOf('days').add(17, 'hours').format('HH:mm')
                    newGroup.messageReservationBefore0 = this.defaultTemplates.reservationBefore0.kakaoTemplateHistoryID.templateContent.replace(/#\{([^}]*)\}/g, '{{$1}}')
                    newGroup.messageReservationBefore0HistoryID = this.defaultTemplates.reservationBefore0.kakaoTemplateHistoryID

                    newGroup.usingMessageReservationBefore1 = false
                    newGroup.messageTimeReservationBefore1 = moment('2000-01-01', 'YYYY-MM-DD').startOf('days').add(17, 'hours').format('HH:mm')
                    newGroup.messageReservationBefore1 = this.defaultTemplates.reservationBefore1.kakaoTemplateHistoryID.templateContent.replace(/#\{([^}]*)\}/g, '{{$1}}')
                    newGroup.messageReservationBefore1HistoryID = this.defaultTemplates.reservationBefore1.kakaoTemplateHistoryID
                    
                    newGroup.usingMessageReservationBefore3 = false
                    newGroup.messageTimeReservationBefore3 = moment('2000-01-01', 'YYYY-MM-DD').startOf('days').add(17, 'hours').format('HH:mm')
                    newGroup.messageReservationBefore3 = this.defaultTemplates.reservationBefore3.kakaoTemplateHistoryID.templateContent.replace(/#\{([^}]*)\}/g, '{{$1}}')
                    newGroup.messageReservationBefore3HistoryID = this.defaultTemplates.reservationBefore3.kakaoTemplateHistoryID
                }
                this.group = newGroup
            }
            else {
                this.group = deepCopy(this.sheetOverlays.selectedGroup) ?? {}
            }
        },
        async validate() {
            this.isErrorName = false
            this.isErrorMessage = false
            if (this.group.title == undefined) { this.isErrorName  = true }
            if (this.group.title?.replaceAll(' ', '') == '') { this.isErrorName = true }
            if (this.group.usingReservationNotification == true) {
                if (this.group.reservationNotificationMessage == undefined) { this.isErrorMessage = true }
                else {
                    let message = deepCopy(this.group.reservationNotificationMessage)
                    if (message.replaceAll(' ', '') == '') { this.isErrorMessage = true }
                }
            }
            if (this.group.usingReservationBNotification == true) {
                if (this.group.reservationBNotificationMessage == undefined) { this.isErrorMessage = true }
                else {
                    let message = deepCopy(this.group.reservationBNotificationMessage)
                    if (message.replaceAll(' ', '') == '') { this.isErrorMessage = true }
                }
            }
            if (await this.isDuplicatedName() == true) {
                this.isErrorNameDuplicated = true
            }


            return this.isErrorName == false && this.isErrorMessage == false && this.isErrorNameDuplicated == false
        },


        // MARK: - Network
        getModel() {
            return {
                _id: this.group._id,
                title: this.group.title,
                hospitalID: this.hospital.selectedHospital._id,
                reservationNotificationTime: this.group.reservationNotificationTime,
                reservationNotificationMessage: this.group.reservationNotificationMessage,
                usingReservationNotification: this.group.usingReservationNotification,
                reservationBNotificationTime: this.group.reservationBNotificationTime,
                reservationBNotificationMessage: this.group.reservationBNotificationMessage,
                usingReservationBNotification: this.group.usingReservationBNotification,

                messageImmediateCreate: this.group?.messageImmediateCreate,
                messageImmediateCreateHistoryID: this.group?.messageImmediateCreateHistoryID?._id,
                messageImmediateUpdate: this.group?.messageImmediateUpdate,
                messageImmediateUpdateHistoryID: this.group?.messageImmediateUpdateHistoryID?._id,
                messageImmediateRemove: this.group?.messageImmediateRemove,
                messageImmediateRemoveHistoryID: this.group?.messageImmediateRemoveHistoryID?._id,

                usingMessageReservationBefore0: this.group?.usingMessageReservationBefore0,
                messageTimeReservationBefore0: this.group?.messageTimeReservationBefore0,
                messageReservationBefore0: this.group?.messageReservationBefore0,
                messageReservationBefore0HistoryID: this.group?.messageReservationBefore0HistoryID?._id,

                usingMessageReservationBefore1: this.group?.usingMessageReservationBefore1,
                messageTimeReservationBefore1: this.group?.messageTimeReservationBefore1,
                messageReservationBefore1: this.group?.messageReservationBefore1,
                messageReservationBefore1HistoryID: this.group?.messageReservationBefore1HistoryID?._id,

                usingMessageReservationBefore3: this.group?.usingMessageReservationBefore3,
                messageTimeReservationBefore3: this.group?.messageTimeReservationBefore3,
                messageReservationBefore3: this.group?.messageReservationBefore3,
                messageReservationBefore3HistoryID: this.group?.messageReservationBefore3HistoryID?._id,
            }
        },

        async loadDefaultTemplates() {
            this.isLoading = true
            try {
                this.defaultTemplates = await this.queryClient.fetchQuery(reservationGroupDefaultTemplatesQueryOptions())
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 조용히 중단
                if (!isApiErrorWithCode(err)) throw err
                this.isLoading = false
                return
            }
            this.isLoading = false
            this.createImmediateTemplate = this.defaultTemplates.createImmediate
            this.updateImmediateTemplate = this.defaultTemplates.updateImmediate
            this.removeImmediateTemplate = this.defaultTemplates.removeImmediate
            this.before0Template = this.defaultTemplates.reservationBefore0
            this.before1Template = this.defaultTemplates.reservationBefore1
            this.before3Template = this.defaultTemplates.reservationBefore3
        },
        async createGroup() {
            let model = this.getModel()

            this.isLoading = true
            let newGroup
            try {
                newGroup = await this.createReservationGroup(model)
            } finally {
                this.isLoading = false
            }
            newGroup.isSelected = true
            let groups = deepCopy(this.sheetFilters.groups)
            groups.splice(this.group.order, 0, newGroup)
            groups.forEach( (g, index) => { g.order = index })

            let data = {
                hospitalID: this.hospital.selectedHospital._id,
                groups: groups
            }
            saveGroups(data)
        },
        async updateGroup() {
            let model = this.getModel()
            this.isLoading = true
            try {
                await this.updateReservationGroup(model)
            } finally {
                this.isLoading = false
            }
        },
        async removeGroup() {
            let model = { _id: this.group._id }
            this.isLoading = true
            try {
                await this.removeReservationGroup(model)
            } catch (err) {
                // 기존 동작 미러링: 삭제는 봉투 에러를 확인하지 않고 팝업을 닫았다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            } finally {
                this.isLoading = false
            }
        },
        async isDuplicatedName() {
            let model = {
                hospitalID: this.hospital.selectedHospital._id,
                title: this.group.title,
                isRemoved: false,
            }
            let groups
            try {
                groups = await this.queryClient.fetchQuery(v2ReservationGroupFindQueryOptions(model))
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
                return
            }

            let target = groups.find(g => g._id == this.group._id)
            if (target != undefined) {
                let index = groups.indexOf(target)
                groups.splice(index, 1)
            }
            if (groups.length > 0) { return true }
            return false
        }
    }
}
</script>